import { type GasPayload } from '@atlaskit/analytics-gas-types';

import { ACTION_SUBJECT_PREFIX } from '../../../constants/analytics';

/** button clicked searchPageQuickFindConnectAppsPill */
export const onQuickFindConnectAppsPillClicked = ({
	attributes,
	nonPrivacySafeAttributes,
}: {
	attributes: Record<string, any>;
	nonPrivacySafeAttributes: Record<string, any>;
}): GasPayload => ({
	eventType: 'ui',
	action: 'clicked',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}QuickFindConnectAppsPill`,
	attributes,
	nonPrivacySafeAttributes,
});
